import { FC, useState, useEffect } from 'react';
import Checkbox from "shared/Checkbox/Checkbox";
import { connect, useDispatch } from "react-redux";
import { updateFilter, clearFilter } from "../../redux/reducers/searchReducer";
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/solid';


export interface FilterSectionProps {
    handleClearFilter?: any;
    formoptions?: any;
    search?: any;
}

const FilterSection: FC<FilterSectionProps> = ({
    handleClearFilter,
    formoptions,
    search,
}) => {

    const dispatch = useDispatch();
    const [showCategory, setShowCategory] = useState(false);
    const [showRegion, setShowRegion] = useState(false);
    const [regions, setRegions] = useState(search?.regions ?? []);
    const [categories, setCategories] = useState(search?.categories ?? []);
    const [regionsText, setRegionsText] = useState(search?.regionsText ?? []);
    const [categoriesText, setCategoriesText] = useState(search?.categoriesText ?? []);

    const handleApplyFilter = () => {
        dispatch(updateFilter({
            regions: regions,
            categories: categories,
            regionsText: regionsText,
            categoriesText: categoriesText
        }));
    }

    const handleResetFilter = () => {
        setRegions([]);
        setCategories([]);
        setRegionsText([]);
        setCategoriesText([])
        dispatch(clearFilter({}));
    }

    const handleClearAll = () => {
        handleResetFilter();
        handleClearFilter();
    }

    const handleCheckboxClick = (item, type) => {
        // add value to array based on type
        if (type === 'regions') {
            setRegions((prev) =>
                prev.includes(item.id) ? prev.filter((val) => val !== item.id) : [...prev, item.id]
            );
            setRegionsText((prev) =>
                (item.name !== "" && prev.includes(item.name)) ? prev.filter((val) => val !== item.name) : [...prev, item.name]
            );
        } else if (type === 'categories') {
            setCategories((prev) =>
                prev.includes(item.id) ? prev.filter((val) => val !== item.id) : [...prev, item.id]
            );
            setCategoriesText((prev) =>
                (item.name !== "" && prev.includes(item.name)) ? prev.filter((val) => val !== item.name) : [...prev, item.name]
            );
        }
    };

    return (
        <div className="rounded-xl border border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 p-6 shadow-md">
            {/* Header Section */}
            <div className="flex items-center justify-between">
                <p className="block font-semibold text-xl sm:text-xl">Filter</p>
                <div>
                    <button
                        className="ml-1 px-4 py-3 rounded-xl bg-neutral-900 text-white dark:bg-neutral-200 dark:text-black"
                        onClick={() => handleResetFilter()}
                    >
                        Reset Filter
                    </button>
                    <button
                        className="ml-1 px-4 py-3 rounded-xl bg-neutral-900 text-white dark:bg-neutral-200 dark:text-black"
                        onClick={() => handleClearAll()}
                    >
                        Clear All
                    </button>
                </div>
            </div>
            {/* Category Section */}
            <div className="mt-5">
                <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => setShowCategory(!showCategory)}
                >
                    <p className="font-semibold text-lg">Category</p>
                    <span className="text-sm text-black dark:text-white">
                        {showCategory ? (
                            <ChevronUpIcon className="w-5 h-5" />
                        ) : (
                            <ChevronDownIcon className="w-5 h-5" />
                        )}
                    </span>
                </div>
                {showCategory && (
                    <>
                        <div className="mt-2">
                            {formoptions?.productgroups.map((item) => (
                                <div key={'cat-checkbox-' + item.name} className="mt-2">
                                    <Checkbox
                                        name={item.name}
                                        label={item.name}
                                        subLabel={item.description}
                                        onChange={() => handleCheckboxClick(item, 'categories')}
                                        checked={categories.includes(item.id)}
                                    />
                                </div>
                            ))}
                        </div>
                        <hr className="my-6 border-t border-neutral-300 dark:border-neutral-700" />
                    </>
                )}
            </div>
            {/* Region Section */}
            <div className="mt-5">
                <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => setShowRegion(!showRegion)}
                >
                    <p className="font-semibold text-lg">Region</p>
                    <span className="text-sm text-black dark:text-white">
                        {showRegion ? (
                            <ChevronUpIcon className="w-5 h-5" />
                        ) : (
                            <ChevronDownIcon className="w-5 h-5" />
                        )}
                    </span>
                </div>
                {showRegion && (
                    <>
                        <div className="mt-2">
                            {formoptions?.regions.map((item) => (
                                <div key={'reg-checkbox-' + item.name} className="mt-2">
                                    <Checkbox
                                        name={item.name}
                                        label={item.name}
                                        subLabel={item.description}
                                        onChange={() => handleCheckboxClick(item, 'regions')}
                                        checked={regions.includes(item.id)}
                                    />
                                </div>
                            ))}
                        </div>
                        <hr className="my-6 border-t border-neutral-300 dark:border-neutral-700" />
                    </>
                )}
            </div>
            {/* Footer Section */}
            <div className="mt-5 flex justify-end">
                <button
                    className="ml-1 px-4 py-3 rounded-xl bg-neutral-900 text-white dark:bg-neutral-200 dark:text-black"
                    onClick={() => handleApplyFilter()}
                >
                    Apply Filter
                </button>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: state.user.user,
    formoptions: state.formoptions.options,
    search: state.search,
});

export default connect(
    mapStateToProps,
    { updateFilter, clearFilter }
)(FilterSection);